import { render, staticRenderFns } from "./stores-view-page.vue?vue&type=template&id=2c2b4ac6&scoped=true&"
import script from "./stores-view-page.vue?vue&type=script&lang=js&"
export * from "./stores-view-page.vue?vue&type=script&lang=js&"
import style0 from "./stores-view-page.vue?vue&type=style&index=0&id=2c2b4ac6&lang=scss&scoped=true&"
import style1 from "./stores-view-page.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./stores-view-page.vue?vue&type=style&index=2&id=2c2b4ac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b4ac6",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QSeparator,QInnerLoading,QSpinnerIos,QItem,QItemSection,QAvatar,QImg,QItemLabel,QCard,QTooltip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QSeparator,QInnerLoading,QSpinnerIos,QItem,QItemSection,QAvatar,QImg,QItemLabel,QCard,QTooltip})
